import { render, staticRenderFns } from "./ReportByChannel.vue?vue&type=template&id=5c9ee3f4&"
import script from "./ReportByChannel.vue?vue&type=script&lang=ts&"
export * from "./ReportByChannel.vue?vue&type=script&lang=ts&"
import style0 from "./ReportByChannel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports